module.exports = __webpack_public_path__ + "CHRYSLER-logo.png";